import React from "react";

/**
 * Shimmer skeleton row matching MarketsTable column geometry.
 */
export default function SkeletonRow() {
  return (
    <tr className="skeleton-row" aria-hidden="true">
      <td>
        <span className="skel skel-rank" />
      </td>
      <td>
        <span className="skel skel-star" />
      </td>
      <td className="skel-coin-cell">
        <span className="skel skel-logo" />
        <span className="skel skel-name" />
      </td>
      <td>
        <span className="skel skel-price" />
      </td>
      <td>
        <span className="skel skel-pct" />
      </td>
      <td>
        <span className="skel skel-pct" />
      </td>
      <td>
        <span className="skel skel-pct" />
      </td>
      <td>
        <span className="skel skel-cap" />
      </td>
      <td>
        <span className="skel skel-vol" />
      </td>
      <td>
        <span className="skel skel-spark" />
      </td>
    </tr>
  );
}
